import { isMobileOnly } from 'react-device-detect';
import { NON_DIGITS_REGEX } from '../constants/regex';
export var isSsr = typeof window === 'undefined';
export var getHost = function () {
    if (isSsr)
        return '';
    if (process.env.NODE_ENV === 'production' && !process.env.DOMAIN_NAME) {
        return "https://".concat(window.location.hostname);
    }
    return window.location.origin;
};
export var getChannelID = function () { return (isMobileOnly ? 2 : 1); };
export var generateXB3TraceID = function () {
    return Math.random().toString(16).substring(2) +
        new Date().getTime().toString(16).substring(0, 15);
};
export var transformToTrialsObj = function (features) {
    // handling mixed contracts
    var featuresArr = Array.isArray(features) ? features : features === null || features === void 0 ? void 0 : features.features;
    var trials = {};
    (featuresArr || []).forEach(function (feature) {
        trials[feature] = true;
    });
    return trials;
};
export var removeNonDigitsFromString = function (string) {
    if (string === void 0) { string = ''; }
    return string.replace(NON_DIGITS_REGEX, '');
};
export var getTmxId = function () {
    var _a, _b, _c;
    var nativeTMXID = '';
    if ((_a = window.__EXPERIENCE_CONTEXT__) === null || _a === void 0 ? void 0 : _a.isConsumerApp) {
        nativeTMXID = getUrlParam('guid');
    }
    return nativeTMXID || ((_c = (_b = window.THD_ACCOUNT_LIB) === null || _b === void 0 ? void 0 : _b.TMX) === null || _c === void 0 ? void 0 : _c.getTMXsessionId());
};
export var getUrlParam = function (key) {
    var _a;
    var searchParams = typeof window !== 'undefined' ? (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search : '';
    var urlParams = new URLSearchParams(searchParams);
    return urlParams.get(key);
};
export var scrollToTop = function () {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
    });
};
export var getHyphenatedGiftCard = function (card) {
    var cardNumber = card.replace(/\D/g, '');
    var cardLength = cardNumber.length;
    if (cardLength > 4 && cardLength <= 12) {
        return "".concat(cardNumber.substring(0, 4), "-").concat(cardNumber.substring(4));
    }
    if (cardLength > 12 && cardLength <= 16) {
        return "".concat(cardNumber.substring(0, 4), "-").concat(cardNumber.substring(4, 12), "-").concat(cardNumber.substring(12));
    }
    if (cardLength > 16) {
        return "".concat(cardNumber.substring(0, 4), "-").concat(cardNumber.substring(4, 12), "-").concat(cardNumber.substring(12, 16), "-").concat(cardNumber.substring(16));
    }
    return cardNumber;
};
export var getSiteKey = function () {
    if (window.location.hostname.endsWith('homedepot.com')) {
        return '6LfEHBkTAAAAAHX6YgeUw9x1Sutr7EzhMdpbIfWJ';
    }
    return '6Le3GRkTAAAAAPpXON0jcJCLrYZnm-ZqyLhbCLbX';
};
export var getAddCreditCardSiteKey = function (isB2B) {
    if (window.location.hostname.endsWith('homedepot.com')) {
        return isB2B
            ? '6LfEHBkTAAAAAHX6YgeUw9x1Sutr7EzhMdpbIfWJ'
            : '6LcAvCkaAAAAANWymwFQVvpFDQIBDCI4NbAvXGJL';
    }
    return isB2B
        ? '6Le3GRkTAAAAAPpXON0jcJCLrYZnm-ZqyLhbCLbX'
        : '6LcXFyAaAAAAANfe3NWwZWC10bjB6W5UoWYCRLFB';
};
export var getPaymentModalsVersion = function () {
    var _a, _b;
    return typeof window !== 'undefined'
        ? (_b = (_a = window.__EXPERIENCE_PROPS__) === null || _a === void 0 ? void 0 : _a.expConfiguration) === null || _b === void 0 ? void 0 : _b.paymentModalsVersion
        : '';
};
